import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getModules = store => store[NAME].modules;
export const getMenus = store => store[NAME].menus;
export const getExclusions = store => store[NAME].exclusions;
export const getModuleList = store => store[NAME].moduleList;
export const getCollaboratorsList = store => store[NAME].collaboratorsList;
export const getTree = store => store[NAME].tree;
export const getResources = store => store[NAME].resources;